import { Controller } from "@hotwired/stimulus"

// A minimal canvas signature pad. Draws with pointer events (covers mouse,
// touch, and pen in one code path) and serializes the stroke to a PNG data
// URL on every pointerup, stored in a hidden field for the form to submit.
export default class extends Controller {
  static targets = ["canvas", "data", "placeholder"]

  connect() {
    this.ctx = this.canvasTarget.getContext("2d")
    this.drawing = false
    this.resizeHandler = () => this.resize()
    this.resize()
    window.addEventListener("resize", this.resizeHandler)
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)
  }

  resize() {
    const canvas = this.canvasTarget
    const ratio = window.devicePixelRatio || 1
    const { width, height } = canvas.getBoundingClientRect()
    const existing = this.hasDataTarget ? this.dataTarget.value : ""

    canvas.width = width * ratio
    canvas.height = height * ratio
    this.ctx.scale(ratio, ratio)
    this.ctx.lineWidth = 2.25
    this.ctx.lineCap = "round"
    this.ctx.lineJoin = "round"
    this.ctx.strokeStyle = "#1a1a1a"

    if (existing) this.drawExisting(existing, width, height)
  }

  drawExisting(dataUrl, width, height) {
    const img = new Image()
    img.onload = () => this.ctx.drawImage(img, 0, 0, width, height)
    img.src = dataUrl
  }

  start(e) {
    e.preventDefault()
    this.drawing = true
    if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = true
    const { x, y } = this.point(e)
    this.ctx.beginPath()
    this.ctx.moveTo(x, y)
  }

  move(e) {
    if (!this.drawing) return
    e.preventDefault()
    const { x, y } = this.point(e)
    this.ctx.lineTo(x, y)
    this.ctx.stroke()
  }

  stop() {
    if (!this.drawing) return
    this.drawing = false
    this.dataTarget.value = this.canvasTarget.toDataURL("image/png")
  }

  clear() {
    const { width, height } = this.canvasTarget.getBoundingClientRect()
    this.ctx.clearRect(0, 0, width, height)
    this.dataTarget.value = ""
    if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = false
  }

  point(e) {
    const rect = this.canvasTarget.getBoundingClientRect()
    return { x: e.clientX - rect.left, y: e.clientY - rect.top }
  }
}
